import {defineMessages} from 'react-intl';

export default defineMessages({
    failed_to_signup: {
        id: 'newsletter.components.form.failed_to_signup',
        defaultMessage: 'Não foi possível cadastrar o seu endereço de email, por favor tente novamente.'
    },
    signup_success: {
        id: 'newsletter.components.form.signup_success',
        defaultMessage: 'Email cadastrado com sucesso!'
    },
    logged_in_cta: {
        id: 'newsletter.components.form.logged_in_cta',
        defaultMessage: 'Quero Receber!'
    },
    not_email: {
        id: 'newsletter.components.form.not_user',
        defaultMessage: 'Não é {email}?'
    },
    use_different_email: {
        id: 'newsletter.components.form.use_different_email',
        defaultMessage: 'Alterar email'
    },
    type_your_email: {
        id: 'newsletter.components.form.type_your_email',
        defaultMessage: 'Digite seu email'
    }
});
